import { Button, Grid, Paper } from "@material-ui/core";
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';
import NotificationProvider from "components/NotificationProvider";
import { TagInput } from "components/TagInput/TagInput";
import { useDeleteSubscriptionMutation, useGetEmailTypesQuery, useGetSubscriptionsForClientQuery, useUpdateSubscriptionMutation } from "features/subscriptions/subscriptionSlice";
import { useEffect, useState } from "react";
import Validator from "services/validator";
import configStyles from "../../configStyles";

const useConfigStyles = configStyles;

const Emails = ({ clientId }) => {
    const configClasses = useConfigStyles();

    let { data: clientSubscribers, error: clientSubscribersError, isLoading: isLoadingClientSubscribers } = useGetSubscriptionsForClientQuery(clientId);
    let { data: emailTypes, error: emailTypesError, isLoading: isLoadingEmailTypes } = useGetEmailTypesQuery();

    let [addSubscription, { isLoading: isAdding }] = useUpdateSubscriptionMutation();
    let [deleteSubscription, { isLoading: isDeleting }] = useDeleteSubscriptionMutation();

    const [existingSubscribers, setExistingSubscribers] = useState([]);
    const [updatedSubscribers, setUpdatedSubscribers] = useState([]);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (clientSubscribers) {
            const mappedSubscribers = clientSubscribers?.map((item) => {
                return {
                    ...item,
                    emailType: emailTypes?.find((emailType) => emailType.id === item.typeId)?.description
                };
            });
            const groupedData = mappedSubscribers?.reduce((acc, obj) => {
                const key = obj.emailType;
                if (!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
            }, {});
            setExistingSubscribers(groupedData);
            setUpdatedSubscribers(groupedData);
        }
    }, [clientSubscribers, emailTypes]);

    const onChange = (key, group, newVal) => {
        const updatedGroup = { ...updatedSubscribers };
        updatedGroup[key] = newVal?.split(',')?.map(email => ({
            email,
            typeId: group?.[0]?.typeId || null
        }));
        setUpdatedSubscribers(updatedGroup);
    }

    const handleSave = async () => {
        setSaving(true);
        var entitiesToAdd = [];
        var entitiesToRemove = [];

        Object.entries(updatedSubscribers).map(([key, subscribers]) => {
            var emailType = subscribers?.[0].typeId;
            var newEmailsArr = subscribers?.filter(e => e.email != null)?.map(e => e.email);
            var existingEmailsArr = existingSubscribers[key]?.filter(e => e.email != null)?.map(e => e.email);

            //emails were added
            if (newEmailsArr?.length > existingEmailsArr?.length) {
                newEmailsArr?.forEach(email => {
                    if (!existingEmailsArr?.includes(email)) {
                        entitiesToAdd.push({
                            email: email,
                            emailTypeId: emailType,
                            clients: [clientId]
                        });
                    }
                });
            }

            //emails were removed
            else {
                existingEmailsArr?.forEach(email => {
                    if (!newEmailsArr?.includes(email)) {
                        entitiesToRemove.push({
                            email: email,
                            emailTypeId: emailType,
                            clientId
                        });
                    }
                });
            }
        });

        entitiesToAdd?.forEach(async (entity) => {
            const res = await addSubscription(entity);
            if (res.error) {

                NotificationProvider.error(`Failed to add ${entity.email} as a subscriber`);
            } else {
                NotificationProvider.success(`Subscriber ${entity.email} was added successfully`);
            }
        });

        entitiesToRemove?.forEach(async (entity) => {
            const res = await deleteSubscription(entity);
            if (res.error) {
                NotificationProvider.error('Failed to remove subscriber');
            } else {
                NotificationProvider.success('Subscriber removed successfully');
            }
        });

        setSaving(false);
    }

    const isLoading = () => isLoadingClientSubscribers || isLoadingEmailTypes;
    const isSaving = () => isAdding || isDeleting;

    return (
        <Paper className={configClasses.card}>
            <div className={configClasses.cardTitle}>Email Configuration</div>
            {isLoading() && <LoadingSpinner loading={isLoading()} />}
            {isSaving() && <LoadingSpinner loading={isSaving()} />}

            <Grid container direction='column' spacing={1} xs={9}>
                {updatedSubscribers &&
                    Object.entries(updatedSubscribers).map(([key, value]) => (
                        <Grid item key={key} className={configClasses.input}>
                            <div className={configClasses.label}>{'Send ' + key + ' Email To'}</div>
                            <div className={configClasses.inputField}>
                                <Authorize profile={permissionProfiles.CLIENT_CONFIG.CLIENT_CONFIG_LOT_PRICING}>
                                    <TagInput
                                        placeholder={'Add email'}
                                        tagString={value?.map(e => e.email).join(',') ?? ""}
                                        onChange={(newVal) => {
                                            onChange(key, value, newVal);
                                        }}
                                        validateFunc={(tag) => {
                                            const res = Validator.validateEmail(tag)
                                            return !!res;
                                        }}
                                    />
                                </Authorize>
                            </div>
                        </Grid>
                    ))}
            </Grid>

            <Grid container justifyContent="flex-end" spacing={1} className={configClasses.btnContainer}>
                <Grid>
                    <Button
                        onClick={() => {
                            setUpdatedSubscribers(existingSubscribers);
                        }}
                        className={configClasses.button}
                        color="primary"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSave}
                        className={configClasses.button}
                        variant="contained"
                        color="primary"
                        disabled={isSaving() || existingSubscribers == updatedSubscribers}
                    >
                        {isSaving() ? "Saving..." : "Save"}
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    );
}

export default Emails;